<div class="container">
  <div class="row head">
    <div class="col-12">
      <span class="title" i18n="parameters-language|@@language">Langue</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12 report-form">
      <div class="container">
        <div class="row generalrows">
          <div class="col-5">
            <ng-select [items]="lngValue" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="language"
              [virtualScroll]='false' [searchable]='false' (change)="handlerChange($event)" notFoundText="---"
              [clearable]='false' placeholder='---'>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/parameters-language/parameters-language.component.html